export default {
  "recommend.contents.title": "こちらもおすすめ",
  "recommend.event.title": "おすすめイベント",
};
